// Material Dashboard 2 PRO React TS Base Styles
import borders from '@theme/base/borders';
import colors from '@theme/base/colors';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

const { borderWidth } = borders;
const { dark } = colors;

// types
type Types = any;

const tableCell: Types = {
  styleOverrides: {
    root: {
      padding: `${pxToRem(12)} ${pxToRem(16)}`,
      borderBottom: `${borderWidth[1]} solid ${dark.main}`
    }
  }
};

export default tableCell;
